import EnumSet from 'Services/enumSet'

interface IQuotationDeadline extends EnumSet {
  now: number
  week: number
  fortnight: number
  month: number
  quarter: number
}

const quotationDeadline = new EnumSet({
  now: { value: 1, description: 'O mais rápido possível' },
  week: { value: 5, description: 'Em até 5 dias' },
  fortnight: { value: 15, description: 'Em até 15 dias' },
  month: { value: 30, description: 'De 1 à 3 meses' },
  quarter: { value: 90, description: 'Mais de 3 meses' },
}) as IQuotationDeadline

export default quotationDeadline